import React from "react";
import { motion } from "framer-motion";
import "../styles/components/_about.scss";

const About = () => {
  // Animation variants for the cards
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.4,
        duration: 0.8,
        ease: "easeOut"
      }
    })
  };

  // Animation variants for the text
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 2,
        duration: 0.9,
        ease: "easeOut"
      }
    })
    
  };

  return (
    <section className="section" id="section2">
      <div className="glass">
        <motion.h1 
          className="section-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={textVariants}
        >
          About us
        </motion.h1>
        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={textVariants}
        >
          MEVEDIR is a one of the leading companies to place environmentally
          sound agricultural practices with its pioneering efforts in Sikkim.
          MEVEDIR is a partnership firm established in 2003. It is an associate
          company of SIBin Group Private Limited (SGPL). Since its inception,
          MEVEDIR has been implementing agro-based projects on Commercial
          Agriculture with a focus on Organic Farming Practices. MEVEDIR is
          currently engaged in designing, execution and monitoring of diverse
          agro-based projects, under its own fold. MEVEDIR firmly believes in
          conserving the fragile Himalayan farming ecosystem through
          environmentally friendly farm practices. In order to fulfill this
          objective, Mevedir is committed to play a pivotal role in taking the
          knowledge and technology in organic farm practices to the farming
          society.
        </motion.p>
        <motion.div 
          className="cards-container"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div 
            className="card"
            variants={cardVariants}
            custom={0}
            whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
          >
            <i className="fa-solid fa-leaf card-icon"></i>
            <h3>Himalayan Ecosystem</h3>
            <p>Farmers play an important role in conservation of the Himalayan ecosystem</p>
          </motion.div>
          <motion.div 
            className="card"
            variants={cardVariants}
            custom={1}
            whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
          >
            <i className="fa-solid fa-users card-icon"></i>
            <h3>Farm Opportunities</h3>
            <p>Create farm-based opportunities for the present and future generation</p>
          </motion.div>
          <motion.div 
            className="card"
            variants={cardVariants}
            custom={2}
            whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
          >
            <i className="fa-solid fa-seedling card-icon"></i>
            <h3>Sustainable Practices</h3>
            <p>Ensure sustainable farm practices by adopting appropriate technologies</p>
          </motion.div>
          <motion.div 
            className="card"
            variants={cardVariants}
            custom={3}
            whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
          >
            <i className="fa-solid fa-square-check card-icon"></i>
            <h3>Fair-Trade Practices</h3>
            <p>Ensure profitable 'fair-trade' practices at all levels</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
